module.exports = __webpack_public_path__ + "static/media/upload-from-pc.90776bc3.svg";